import styled from 'styled-components';
import { sizes } from '../../config/general';
import { theme } from '../../config/theme';

export const SectionWrapper = styled.span`
	& > p {
		font-size: 20px;
		padding-right: 10%;
	}

	& a {
		color: ${theme.text.primary.active};
		text-decoration: none;
	}

	& a.anchor {
		display: block;
		position: relative;
		top: calc(-${sizes.nav.height.desktop} - 10px);
		visibility: hidden;
	}

`;

export const Header = styled.h4`
	font-size: 40px;
	font-weight: 400;
`;


// WEBPACK FOOTER //
// ./src/components/section/components.js